import BaseModel from '../core/BaseModel'
export default class HistoryControlMeasuresModel extends BaseModel {
    constructor() {
        super({
            tableName: 'history_control_measures', label: " Lịch Sử Biện Pháp Kiểm Soát", display_key: 'name',name: "history_control_measures",
        }, {
          stt: { 
            name: "stt", 
            label: "STT",
            class: 'center width_150 common',
            computed: (data, index) => {
              data.stt = index + 1;
            }
          },
          id: { 
            name: 'id', 
            type: "Uuid", 
            label: 'ID', 
            primaryKey: true,  
            display: false
          },
          evaluation_form_name: { 
            name: 'evaluation_form_name', 
            type: "TEXT", 
            label: 'Phiếu đánh giá',
            filter: { type: "input", match: "contains" },
          },
          situation_name: { 
            name: 'situation_name', 
            type: "TEXT", 
            label: 'Tình huống',
            filter: { type: "input", match: "contains" },
          },
          danger_name: { 
            name: 'danger_name', 
            type: "TEXT", 
            label: 'Mối nguy',
            filter: { type: "input", match: "contains" },
          },
          control_measures_name: { 
            name: 'control_measures_name', 
            type: "TEXT", 
            label: 'Biện pháp',
            filter: { type: "input", match: "contains" },
          },
          control_measures_type : {
            name: 'type', 
            type: "Selection", 
            // custom: 'Selection',
            label: 'Loại',
            // class: 'center',
            options: [
              {label: "Lặp lại",value: "LOOP"},
              {label: "Có thời hạn",value: "TIME"}
            ],
            filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' }
          },
          status : {
            name: 'status', 
            type: "Selection", 
            label: 'Trạng thái biện pháp',
            // class: 'center',
            options: [
              {label: "Đề xuất",value: "WAITING",style: 'color: #333333;'},
              {label: "Đã duyệt",value: "APPROVE",style: 'color: #0086C4;'},
              {label: "Không duyệt",value: "NOT_APPROVE",style: 'color: #F5564E;'},
              {label: "Đã hủy",value: "CANCEL",style: 'color: #F5564E;'},
              {label: "Mới",value: "NEW",style: 'color: #333333;'},
              {label: "Đang thực hiện",value: "INPROCESS",style: 'color: #179DA8;'},
              {label: "Tạm hoãn",value: "PENDING",style: 'color: #CFA71A;'},
              {label: "Kết thúc",value: "DONE",style: 'color: #00973C;'},
            ],
            filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' }
          },
          regulations : {
            name: 'regulations', 
            type: "Selection", 
            label: 'Tuân thủ',
            // class: 'center',
            options: [
              {label: "Tuân thủ",value: "YES"},
              {label: "Không",value: "NO"},
            ],
            filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' }
          },
          note: { 
            name: 'note', 
            type: "TEXT", 
            label: 'Kiến nghị',
          },
          file: { 
            name: 'file', 
            type: "CustomUrl", 
            label: 'File',
          },
          updated_name: {
            renamefs:"updated_name",
            type: "String",
            label: "Người cập nhật"
          },
          created_at : {
            name: 'updated_at',
            type: "Datetime",
            label: 'Ngày cập nhật',
          },
        })
    }

}